import script from "./deviceAlarmRule.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceAlarmRule.vue?vue&type=script&setup=true&lang=js"

import "./deviceAlarmRule.vue?vue&type=style&index=0&id=4724001e&lang=less"

const __exports__ = script;

export default __exports__